import PropTypes from 'prop-types';

export const StepPropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired,
  hideProgress: PropTypes.bool,
  readOnly: PropTypes.bool,
  showStep: PropTypes.bool
};
